<div *ngIf="!notificationMode">
  <button type="button" class="btn btn-primary btn-sm" (click)="openFormModal(reminder_form)">
    <i class="fas fa-plus-circle"></i>
    &nbsp;New Reminder
  </button>
  <button type="button" class="btn btn-primary btn-sm" *ngFor="let field of reminderable_fields" (click)="openFormModal(reminder_form, field.value)">
    <i class="fas fa-plus-circle"></i>
    &nbsp;{{ field.label }}
  </button>
  <div class="py-1"></div>
  <div *ngIf="canViewAllReminders">
    <select name='userIdForReminders' ngDefaultControl class="form-control mb-2" [(ngModel)]="userIdForReminders" (change)="loadReminders()">
      <option *ngFor="let user of users" [value]="user.id">{{ user.full_name }}</option>
    </select>
    <a [href]="pdfUrl"  class="btn btn-primary btn-sm">
      Download&nbsp;<i class="fas fa-file-pdf"></i>
    </a>
    <div class="pb-1"></div>
  </div>
  <div class="btn-group btn-group-sm float-right">
    <button type="button" class="btn btn-sm btn-outline-primary" [ngClass]="{ active: searchParams.type == 'pending' }" [disabled]="loadingReminders" (click)="loadReminders('pending')">Pending</button>
    <button type="button" class="btn btn-sm btn-outline-primary" [ngClass]="{ active: searchParams.type == 'dismissed' }" [disabled]="loadingReminders" (click)="loadReminders('dismissed')">Dismissed</button>
    <button type="button" class="btn btn-sm btn-outline-primary" [ngClass]="{ active: searchParams.type == 'upcoming' }" [disabled]="loadingReminders" (click)="loadReminders('upcoming')">Upcoming</button>
  </div>
</div>
<button type="button" class="btn btn-outline-primary btn-sm" (click)="loadReminders()" [disabled]="loadingReminders">
  <i class="fas fa-redo" *ngIf="!loadingReminders"></i>
  <i class="fas fa-spinner fa-fw fa-pulse" *ngIf="loadingReminders"></i>
</button>
<button
  type="button"
  class="btn btn-danger btn-sm ml-2"
  *ngIf="hasSelectedReminders && searchParams.type != 'dismissed'"
  (click)="dismissSelectedReminders()"
  [disabled]="dismissingSelected">
  <span *ngIf="!dismissingSelected">
    <i class="fas fa-bell-slash"></i>
    &nbsp;Dismiss Selected ({{ selectedReminderIds.size }})
  </span>
  <span *ngIf="dismissingSelected">
    <i class="fas fa-spinner fa-fw fa-pulse"></i>
    &nbsp;Dismissing...
  </span>
</button>
<div class="clearfix"></div>
<div class="pt-1"></div>
<div *ngIf="reminders && reminders.length > 0 && !loadingReminders">
  <table class="table table-sm">
    <thead>
      <tr *ngIf="reminderable_type">
        <th style="width: 40px" *ngIf="searchParams.type != 'dismissed'">
          <input
            type="checkbox"
            [checked]="allSelected"
            (change)="toggleSelectAll()"
            title="Select/Deselect All">
        </th>
        <th>At</th>
        <th></th>
      </tr>
      <tr *ngIf="!reminderable_type">
        <th style="width: 40px" *ngIf="searchParams.type != 'dismissed'">
          <input
            type="checkbox"
            [checked]="allSelected"
            (change)="toggleSelectAll()"
            title="Select/Deselect All">
        </th>
        <th>At</th>
        <th>Desc</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let reminder of reminders; let i = index" [title]="reminder.tooltip">
        <td style="width: 40px; text-align: center" *ngIf="searchParams.type != 'dismissed'">
          <input
            type="checkbox"
            [checked]="isReminderSelected(reminder.id)"
            (change)="toggleReminderSelection(reminder.id)">
        </td>
        <td style="min-width: 128px !important">
          <span *ngIf="!reminder.rrule" [title]="reminder.start_time_str">
            {{ reminder.start_date_str }}
          </span>
          <span *ngIf="reminder.rrule">
            <span [ngClass]="{ 'text-danger': !reminder.next_date_str, 'text-success': reminder.next_date_str }" [title]="reminder.next_date_str ? reminder.next_time_str : reminder.recurring_tooltip"> {{ reminder.next_date_str || 'Closed' }}&nbsp; </span>
            <i class="fas fa-redo text-info" [title]="reminder.recurring_tooltip"></i>
          </span>
          <span *ngIf="showId">
            <br />
            <em class="text-muted" title="Id">{{ reminder.id }}</em>
          </span>
          <br />
          <div class="btn-group btn-group-sm">
            <button class="btn btn-sm btn-outline-info p-1" title="View" (click)="showReminder(reminder, reminder_show)">
              <i class="fas fa-folder-open"></i>
            </button>
            <button class="btn btn-sm btn-outline-primary p-1" title="Edit" (click)="editReminder(reminder, reminder_form, false)">
              <i class="fas fa-pencil-alt"></i>
            </button>
            <button class="btn btn-sm btn-outline-danger p-1" title="Delete" [disabled]="reminder.deleting" (click)="deleteReminder(reminder, i)">
              <i class="fas fa-trash"></i>
            </button>
            <button class="btn btn-sm btn-outline-info p-1" title="Dismiss" [disabled]="reminder.dismissing" *ngIf="searchParams.type != 'dismissed'" (click)="dismiss(reminder)">
              <span *ngIf="!reminder.dismissing">
                <i class="fas fa-bell-slash"></i>
              </span>
              <span *ngIf="reminder.dismissing">
                <i class="fas fa-spinner fa-pulse fa-fw"></i>
              </span>
            </button>
          </div>
        </td>
        <td style="width: calc(100% - 128px)">
          <div style="max-width: 100% !important;">
            <a *ngIf="!reminderable_type" target="_blank" [routerLink]="reminder.reminderable_url" [title]='reminder.reminderable_title'>
              {{ reminder.reminderable_title_str }}
            </a>
            <span *ngIf="reminder.matter_id && reminder.matter_number && reminder.reminderable_url != ('/matters/' + reminder.matter_id)">
              &nbsp;|&nbsp;<a target="_blank" [routerLink]="'/matters/' + reminder.matter_id">Matter - {{ reminder.matter_number }}</a>
            </span>
            <br *ngIf="!reminderable_type" />
            <div class="float-right">
              <span *ngIf="reminder.delivery_methods">
                <span *ngFor="let method of reminder.delivery_methods">
                  <i
                    class="fas"
                    [ngClass]="{
                      'fa-desktop': method == 'Chat' || method == 'Browser Notification' || method == 'Element',
                      'fa-envelope-square': method == 'Email',
                      'fa-mobile-alt': method == 'Phone Text'
                    }"
                    [title]="method == 'Chat' ? 'Browser Notification' : method"
                  ></i
                  >&nbsp;
                </span>
              </span>
              <span *ngIf="reminder.opened" title="Dismissed">
                <i class="fas fa-bell-slash text-info"></i>
              </span>
            </div>
            <div [title]="reminder.topic" class="font-italic font-weight-bold text-truncate">
              {{ reminder.topic_str }}
            </div>
            <span *ngIf="reminder.topic_str">
              <!--<br />-->
            </span>
            <div [title]="reminder.body" style="max-height: 3em !important; overflow-y: hidden !important">
              {{ reminder.body_str }}
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #reminder_show>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      Reminder&nbsp;&nbsp;
      <span *ngIf="selectedReminder">
        <small>
          <small>
            <span *ngIf="selectedReminder.delivery_methods">
              <span *ngFor="let method of selectedReminder.delivery_methods">
                <i
                  class="fas"
                  [ngClass]="{
                    'fa-desktop': method == 'Chat' || method == 'Browser Notification' || method == 'Element',
                    'fa-envelope-square': method == 'Email',
                    'fa-mobile-alt': method == 'Phone Text'
                  }"
                  [title]="method == 'Chat' ? 'Browser Notification' : method"
                ></i
                >&nbsp;
              </span>
            </span>
            <span *ngIf="selectedReminder.opened" title="Dismissed">
              <i class="fas fa-bell-slash text-info"></i>
            </span>
          </small>
        </small>
      </span>
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef!.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <th scope="row">Actions</th>
          <td>
            <div class="btn-group btn-group-sm">
              <button class="btn btn-sm btn-outline-primary p-1" title="Edit" (click)="editReminder(selectedReminder, reminder_form, true)">
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button class="btn btn-sm btn-outline-danger p-1" title="Delete" [disabled]="selectedReminder.deleting" (click)="deleteReminder(selectedReminder)">
                <i class="fas fa-trash"></i>
              </button>
              <button class="btn btn-sm btn-outline-info p-1" title="Dismiss" [disabled]="selectedReminder.dismissing" *ngIf="searchParams.type != 'dismissed' && !selectedReminder.opened" (click)="dismiss(selectedReminder)">
                <span *ngIf="!selectedReminder.dismissing">
                  <i class="fas fa-bell-slash"></i>
                </span>
                <span *ngIf="selectedReminder.dismissing">
                  <i class="fas fa-spinner fa-pulse fa-fw"></i>
                </span>
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="!reminderable_type && !selectedReminder.hideReminderableRow">
          <th scope="row">For {{ selectedReminder.reminderable_type_str }}</th>
          <td>
            <a target="_blank" [routerLink]="selectedReminder.reminderable_url">
              {{ selectedReminder.reminderable_title_name }}
            </a>
            <span *ngIf="selectedReminder.matter_id && selectedReminder.matter_number">
              &nbsp;|&nbsp;<a target="_blank" [routerLink]="'/matters/' + selectedReminder.matter_id">Matter - {{ selectedReminder.matter_number }}</a>
            </span>
          </td>
        </tr>
        <tr *ngIf="!selectedReminder.rrule">
          <th scope="row">At Time</th>
          <td>
            {{ selectedReminder.start_date_str }}
            &nbsp;
            {{ selectedReminder.start_time_str }}
          </td>
        </tr>
        <tr *ngIf="selectedReminder.rrule">
          <th scope="row">Recurring</th>
          <td>{{ selectedReminder.rrule_text }}</td>
        </tr>
        <tr *ngIf="selectedReminder.rrule">
          <th scope="row">Next At</th>
          <td>
            <span [ngClass]="{ 'text-danger': !selectedReminder.next_date_str, 'text-success': selectedReminder.next_date_str }"> {{ selectedReminder.next_date_str ? selectedReminder.next_date_str + ' ' + selectedReminder.next_time_str : 'Closed' }}&nbsp; </span>
          </td>
        </tr>
        <tr *ngIf="selectedReminder.rrule">
          <th scope="row">
            Next Occurrences
            <span *ngIf="selectedReminder.next_occurrences && selectedReminder.next_occurrences.length >= 5"> &nbsp;(upto 5) </span>
          </th>
          <td>
            <div *ngIf="selectedReminder.next_occurrences && selectedReminder.next_occurrences.length > 0">
              <div *ngFor="let occurrence of selectedReminder.next_occurrences">{{ occurrence.date }} {{ occurrence.time }}</div>
            </div>
            <span class="text-muted" *ngIf="!selectedReminder.next_occurrences || selectedReminder.next_occurrences.length < 1"> N/A </span>
          </td>
        </tr>
        <tr *ngIf="selectedReminder.rrule">
          <th>{{ selectedReminder.next_date_str ? 'Ends' : 'Ended' }}&nbsp;On</th>
          <td>{{ selectedReminder.end_date_str || 'Repeats Forever' }}</td>
        </tr>
        <tr *ngIf="selectedReminder.topic">
          <th scope="row" class="text-center p-3" colspan="2">{{ selectedReminder.topic }}</th>
        </tr>
        <tr *ngIf="selectedReminder.body">
          <td colspan="2" class="text-center p-3">{{ selectedReminder.body }}</td>
        </tr>
        <tr *ngIf="selectedReminder.event_info && selectedReminder.event_info.start">
          <th scope="row">Event Info</th>
          <td>
            <table class="table table-sm table-bordered">
              <tbody>
                <tr>
                  <th scope="row">Matter</th>
                  <td>
                    <a [routerLink]="'/matters/' + selectedReminder.event_info.matter_id">{{ selectedReminder.event_info.matter_name }}</a>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Start</th>
                  <td>{{ selectedReminder.event_info.start }}</td>
                </tr>
                <tr>
                  <th scope="row">End</th>
                  <td>{{ selectedReminder.event_info.end }}</td>
                </tr>
                <tr>
                  <th scope="row">Duration</th>
                  <td>{{ selectedReminder.event_info.duration }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
<ng-template #reminder_form>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      Reminder for <span [innerHTML]="formOptions.title || '*'"></span>
      <small>
        <small class="text-muted font-italic" *ngIf="selectedReminder.id"><br />(Saving with a future start date will activate the reminder if dismissed already)</small>
      </small>
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeFormModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group" *ngIf="!reminderable_type && (selectedReminder.reminderable_type == 'Contact' || selectedReminder.reminderable_type == 'Matter' || !selectedReminder.reminderable_type)">
      <label>For</label>
      <select class="form-control" name='reminderable_type' ngDefaultControl [(ngModel)]="selectedReminder.reminderable_type" (change)="selectedReminder.reminderable_id = undefined; formOptions.title = undefined">
        <option *ngFor="let reminderableType of formOptions.reminderable_types" [value]="reminderableType">{{ reminderableType }}</option>
      </select>
    </div>
    <div class="form-group" *ngIf="!reminderable_type">
      <app-contact-search
        [include_item]="true"
        *ngIf="selectedReminder.reminderable_type == 'Contact'"
        [contactId]="selectedReminder.reminderable_id"
        (contact)="formOptions.title = 'Contact - <a target=&quot;_blank&quot; routerLink=&quot;/contacts/' + $event.value + '&quot;>' + $event.label + '</a>'"
        (contact_id)="selectedReminder.reminderable_id = $event"
      ></app-contact-search>
      <app-matter-search
        [include_item]="true"
        *ngIf="selectedReminder.reminderable_type == 'Matter'"
        [matterId]="selectedReminder.reminderable_id"
        (matter)="formOptions.title = 'Matter - <a target=&quot;_blank&quot; routerLink=&quot;/matters/' + $event.value + '&quot;>' + $event.label + '</a>'"
        (matter_id)="selectedReminder.reminderable_id = $event"
      ></app-matter-search>
    </div>
    <hr *ngIf="!reminderable_type" />
    <div class="form-group">
      <label>Topic</label>
      <input type="text" class="form-control" placeholder="Reminder description" name="topic" ngDefaultControl [(ngModel)]="selectedReminder.topic" />
      <small class="form-text text-muted">A topic is required</small>
    </div>
    <hr />
    <div class="form-row mb-3">
      <div class="col-6">
        <label>Repeat</label>
        <select class="form-control" name='recurring_freq' ngDefaultControl [(ngModel)]="recurring.freq" (change)="buildRrule()">
          <option *ngFor="let repeat of rruleService.repeats" [value]="repeat.value">{{ repeat.label }}</option>
        </select>
      </div>
      <div class="col-6" *ngIf="recurring.freq && recurring.freq != 'NONE'">
        <label>Every</label>
        <div class="input-group">
          <input type="number" name='recurring_interval' ngDefaultControl [(ngModel)]="recurring.interval" (keyup)="buildRrule()" (change)="buildRrule()" class="form-control" />
          <div class="input-group-append">
            <span class="input-group-text">
              <span *ngIf="recurring.freq == 'DAILY'">day(s)</span>
              <span *ngIf="recurring.freq == 'WEEKLY'">week(s)</span>
              <span *ngIf="recurring.freq == 'MONTHLY'">month(s)</span>
              <span *ngIf="recurring.freq == 'YEARLY'">year(s)</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="recurring.freq == 'MONTHLY'">
      <label>Repeat by</label>
      <br />
      <div class="custom-control custom-radio custom-control-inline" (click)="recurringDays.monthType = 'day_of_month'; buildRrule()">
        <input name='recurringDays' type="radio" class="custom-control-input" [checked]="recurringDays.monthType == 'day_of_month' || !recurringDays.monthType" />
        <label class="custom-control-label">Day of month</label>
      </div>
      <div class="custom-control custom-radio custom-control-inline" (click)="recurringDays.monthType = 'day_of_week'; buildRrule()">
        <input name='recurringDays' type="radio" class="custom-control-input" [checked]="recurringDays.monthType == 'day_of_week'" />
        <label class="custom-control-label">Day of week</label>
      </div>
    </div>
    <div class="form-group" *ngIf="recurring.freq == 'WEEKLY'">
      <label *ngIf="recurring.freq == 'WEEKLY'">On Weekdays</label>
      <br *ngIf="recurring.freq == 'WEEKLY'" />
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-outline-secondary"
          style="min-width: 44px !important"
          *ngFor="let weekDay of rruleService.weekDays"
          (click)="recurringDays.by_week_day[weekDay.value] = !!!recurringDays.by_week_day[weekDay.value]; buildRrule()"
          [ngClass]="{ active: recurringDays.by_week_day[weekDay.value] }"
        >
          {{ weekDay.label }}
        </button>
      </div>
    </div>
    <div class="form-group" *ngIf="recurring.freq == 'MONTHLY' && recurringDays.monthType == 'day_of_week'">
      <div class="d-flex">
        <div style="line-height: 38px !important">
          1st Week
          <br />
          2nd Week
          <br />
          3rd Week
          <br />
          4th Week
          <br />
          5th Week
          <br />
          Last Week
        </div>
        <div class="flex-grow-1">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-outline-secondary"
              style="min-width: 44px !important"
              *ngFor="let weekDay of rruleService.weekDays"
              (click)="recurringDays.by_day['1_' + weekDay.value] = !recurringDays.by_day['1_' + weekDay.value]; buildRrule()"
              [ngClass]="{ active: !!recurringDays.by_day['1_' + weekDay.value] }"
            >
              {{ weekDay.label }}
            </button>
          </div>
          <br />
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-outline-secondary"
              style="min-width: 44px !important"
              *ngFor="let weekDay of rruleService.weekDays"
              (click)="recurringDays.by_day['2_' + weekDay.value] = !recurringDays.by_day['2_' + weekDay.value]; buildRrule()"
              [ngClass]="{ active: recurringDays.by_day['2_' + weekDay.value] }"
            >
              {{ weekDay.label }}
            </button>
          </div>
          <br />
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-outline-secondary"
              style="min-width: 44px !important"
              *ngFor="let weekDay of rruleService.weekDays"
              (click)="recurringDays.by_day['3_' + weekDay.value] = !recurringDays.by_day['3_' + weekDay.value]; buildRrule()"
              [ngClass]="{ active: recurringDays.by_day['3_' + weekDay.value] }"
            >
              {{ weekDay.label }}
            </button>
          </div>
          <br />
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-outline-secondary"
              style="min-width: 44px !important"
              *ngFor="let weekDay of rruleService.weekDays"
              (click)="recurringDays.by_day['4_' + weekDay.value] = !recurringDays.by_day['4_' + weekDay.value]; buildRrule()"
              [ngClass]="{ active: recurringDays.by_day['4_' + weekDay.value] }"
            >
              {{ weekDay.label }}
            </button>
          </div>
          <br />
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-outline-secondary"
              style="min-width: 44px !important"
              *ngFor="let weekDay of rruleService.weekDays"
              (click)="recurringDays.by_day['5_' + weekDay.value] = !recurringDays.by_day['5_' + weekDay.value]; buildRrule()"
              [ngClass]="{ active: recurringDays.by_day['5_' + weekDay.value] }"
            >
              {{ weekDay.label }}
            </button>
          </div>
          <br />
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-outline-secondary"
              style="min-width: 44px !important"
              *ngFor="let weekDay of rruleService.weekDays"
              (click)="recurringDays.by_day['-1_' + weekDay.value] = !recurringDays.by_day['-1_' + weekDay.value]; buildRrule()"
              [ngClass]="{ active: recurringDays.by_day['-1_' + weekDay.value] }"
            >
              {{ weekDay.label }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="recurring.freq == 'MONTHLY' && (recurringDays.monthType == 'day_of_month' || !recurringDays.monthType)">
      <div *ngFor="let monthDayArray of rruleService.monthDays">
        <div class="btn-group d-inline-block">
          <button
            type="button"
            class="btn btn-outline-secondary"
            style="min-width: 44px !important"
            *ngFor="let monthDay of monthDayArray"
            (click)="recurringDays.by_month_day[monthDay] = !recurringDays.by_month_day[monthDay]; buildRrule()"
            [ngClass]="{ active: recurringDays.by_month_day[monthDay] }"
          >
            {{ monthDay < 10 ? '&nbsp;' : '' }}{{ monthDay }}
          </button>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="selectedReminder.rrule_text">
      <p>
        <b>Repeats:&nbsp;</b><span class="text-info">{{ selectedReminder.rrule_text }}</span>
      </p>
    </div>
    <div class="form-row">
      <div class="col-6">
        <label class="float-left pb-1" style="position: absolute"
          >When&nbsp;<small class="form-text text-muted d-inline">({{ recurring.freq && recurring.freq != 'NONE' ? 'First date for the reminder' : 'Reminder date' }})</small></label
        >
        <div style="height: 5px"></div>
        <app-datetime-picker [datetime]="startDateStruct" (ngbResult)="selectedReminder.start_date_struct = $event"></app-datetime-picker>
        <span class="form-text text-muted" *ngIf="formSubmitted && !selectedReminder.start_date_struct">Reminder date needs to be set</span>
      </div>
      <div class="col-6" *ngIf="recurring.freq && recurring.freq != 'NONE'">
        <label class="float-left pb-1" style="position: absolute">Until</label>
        <div class="d-flex">
          <div class="pr-2">
            <div style="height: 37px"></div>
            <div class="custom-control custom-checkbox" (click)="selectedReminder.repeats_forever = !selectedReminder.repeats_forever">
              <input name='repeats_forever' type="checkbox" class="custom-control-input" [checked]="selectedReminder.repeats_forever" />
              <label class="custom-control-label">Repeat forever</label>
            </div>
          </div>
          <div class="flex-grow-1" *ngIf="!selectedReminder.repeats_forever">
            <app-datetime-picker [showTimePicker]="false" [datetime]="endDateStruct" (ngbResult)="selectedReminder.end_date_struct = $event"></app-datetime-picker>
            <small class="form-text text-muted">Last date for reminder</small>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="form-row mb-3" *ngIf="!selectedReminder.id">
      <div class="col-sm-6">
        <label
          >Recipients of Reminder&nbsp;<app-badge badgeType="primary">{{ recipients.length }}</app-badge></label
        >
        <select [disabled]="!!selectedReminder.id" class="form-control" name="selected_recipient" ngDefaultControl [(ngModel)]="selectedRecipient" (change)="selectRecipient()">
          <option [ngValue]="{}" class="text-info">Select a recipient to add</option>
          <option *ngFor="let user of formOptions.users" [ngValue]="user">{{ user.label }}</option>
        </select>
        <small class="form-text text-muted">Select to add</small>
        <span class="form-text text-danger" *ngIf="recipients.length < 1 && formSubmitted">Atleast one recipient must be selected</span>
      </div>
      <div class="col-sm-6">
        <ul class="list-group">
          <li class="list-group-item" *ngFor="let recipient of recipients">
            <div class="float-right">
              <a href="#" (click)="removeRecipient(recipient); $event.preventDefault()" class="text-danger">
                <i class="fas fa-times"></i>
              </a>
            </div>
            {{ recipient.label }}
            <span class="text-danger" title="Texting not enabled" *ngIf="selectedReminder.delivery_methods.indexOf('Phone Text') > -1 && !recipient.allow_phone_text">
              &nbsp;
              <i class="fas fa-mobile-alt"></i>
              <i class="fas fa-slash" style="position: relative; left: -15px"></i>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <hr *ngIf="!selectedReminder.id" />
    <div class="form-group">
      <label>Notify through</label>
      <br />
      <div *ngFor="let option of formOptions.deliver_options" class="custom-control custom-checkbox custom-control-inline" (click)="option.checked = !option.checked; setDeliveryMethods()">
        <input type="checkbox" [name]='"delivery_method_" + option.label' [checked]="option.checked" class="custom-control-input" />
        <label class="custom-control-label">{{ option.label }}</label>
      </div>
      <span class="form-text text-danger" *ngIf="selectedReminder.delivery_methods.length < 1 && formSubmitted">Atleast one notification option needs to be checked</span>
    </div>
    <div class="form-group">
      <label>Notes</label>
      <textarea class="form-control" name="description" ngDefaultControl [(ngModel)]="selectedReminder.body"></textarea>
    </div>
    <div class="form-row mb-3">
      <div class="col-6">
        <button type="button" class="btn btn-primary btn-block" (click)="save()" [disabled]="formSubmitting">
          Save<span *ngIf="formSubmitting">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
        </button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-outline-secondary btn-block" [disabled]="formSubmitting" (click)="closeFormModal()">Cancel</button>
      </div>
    </div>
  </div>
</ng-template>
